<template>
    <div class="justifyContentBOX">
         <HotelDailyCost  @hotelDailyCost ="hotelDailyCostValue"/>
         <b-field />
          <b-checkbox type="is-primary" v-model="obj.isSetExceptionCities" >
            <b-field  label="Do you want to set exception cities that will have a different price threshold?"></b-field>
          </b-checkbox>
          <div v-if="this.obj.isSetExceptionCities"  class="edittravelpolicy2" >
          <b-field class="HotelAverageBox"  label="Hotel average nightly cost for exceptions cities is more than $">
            <b-input  type="number" v-model="obj.exceptionCitiesDailyCost" @input="$emit('hotelDailyCostForExceptionCities',obj)"/>
            </b-field>
            <b-field >
            <TagAutocomplete
            placeholder="e.g. Boston"
            icon="magnify"
            :chainData="getCityCode"
            :selected="obj.exceptionCities"
            @list="getSelectedExceptionCities"
            ></TagAutocomplete>
         </b-field></div>
    </div>
</template>
<script>
import HotelDailyCost from './HotelDailyCost.vue';
import TagAutocomplete from '../../Tags/TagAutocomplete.vue';
import { eventBus } from '../../../main';

export default{
    name: "HotelDailyCostWithExceptionCities",
    props : { 
        hotelExceptionCities : null
     },
    components: {HotelDailyCost,TagAutocomplete},
    data(){
        return {
            obj : {
                isSetExceptionCities: false,
                exceptionCities : [],
                exceptionCitiesDailyCost : null,
                dailyCost :null
            }
        }
    },
    computed:{
        getCityCode(){
            return Object.entries(this.$globals.cityCodes)
        }
    },
    methods:{

        hotelDailyCostValue(val) {
         this.obj.dailyCost=val;
         this.$emit('hotelDailyCostForExceptionCities',this.obj);
        },
        getSelectedExceptionCities(){
        this.$emit('hotelDailyCostForExceptionCities',this.obj);
        }
    },
    mounted() {
    this.$emit('hotelDailyCostForExceptionCities',this.obj);
    this.obj = this.hotelExceptionCities
    eventBus.$emit('hotelDailyCost',this.obj.dailyCost)
    }
}
</script>